import React, {Component} from 'react';
import {Col} from "reactstrap";
import NumberFormat from "react-number-format";
import ReactLoading from "react-loading";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";

class ESmmPriceTable extends Component {

    constructor(props) {
        super(props);
        this.state ={};
    }

    render() {
        return (
            <Col sm={12}>
                <table className="" style={{textAlign: 'center', paddingBottom:'10px'}}>
                    <thead>
                    <tr style={{backgroundColor: '#ebedf0'}}>
                        <th>Yıl</th>
                        <th>Ücret Nedeni</th>
                        <th>Brüt Tutar</th>
                        <th>Stopaj Tutarı</th>
                        <th>KDV Tutarı</th>
                        <th>KDV Tevkifatı Tutarı</th>
                        <th>Net Ücret</th>
                        <th>Ödenecek Tutar</th>
                        <th>İşlemler</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.loading &&
                    <tr>
                        <td colSpan={7}>{
                            <ReactLoading
                                type="spinningBubbles"
                                style={{width:"70px", height: "70px", margin: "20px auto 0 auto", fill: "#888"}}/>}
                        </td>
                    </tr>
                    }

                    {!this.props.loading && this.props.content && this.props.content.filter((option)=>option.type === this.props.type && option.year === this.props.selectedYear).map((document, index) =>
                        <tr key={index+"_"+document.recordId}>
                            <td style={{margin:"0px"}}>
                                <NumberFormat   value={document.year}
                                                isNumericString={true}
                                                displayType="text"/>

                            </td>
                            <td style={{margin:"0px"}}><TextOverFlowTooltip text={document.itemName} maxLength={100}/></td>
                            <td style={{margin:"0px"}}>
                                <NumberFormat value={document.brut}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator={'.'}
                                              decimalSeparator={','}
                                              suffix="₺"
                                              displayType="text"/>

                            </td>
                            <td style={{margin:"0px"}}>
                                <NumberFormat value={document.stoppageAmount}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator={'.'}
                                              decimalSeparator={','}
                                              suffix="₺"
                                              displayType="text"/>

                            </td>
                            <td style={{margin:"0px"}}>
                                <NumberFormat value={document.kdvAmount}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator={'.'}
                                              decimalSeparator={','}
                                              suffix="₺"
                                              displayType="text"/>

                            </td>
                            <td style={{margin:"0px"}}>
                                <NumberFormat value={document.withHoldingCodeAmount}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator={'.'}
                                              decimalSeparator={','}
                                              suffix="₺"
                                              displayType="text"/>

                            </td>
                            <td style={{margin:"0px"}}>
                                <NumberFormat value={document.net}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator={'.'}
                                              decimalSeparator={','}
                                              suffix="₺"
                                              displayType="text"/>

                            </td>
                            <td style={{margin:"0px"}}>
                                <NumberFormat value={document.payableAmount}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                              thousandSeparator={'.'}
                                              decimalSeparator={','}
                                              suffix="₺"
                                              displayType="text"/>

                            </td>
                            <td style={{margin:"0px"}}>{
                                <div>
                                    <button type="button"
                                            style={{margin: "0", background: '#3fb0ac'}}
                                            onClick={() => this.props.calculate(document,false)}
                                            className="btn btn-sm">
                                        <i className="fa fa-check"><p style={{paddingLeft:4,display:'inline'}}>Uygula</p></i>
                                    </button>
                                </div>
                            }</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </Col>
        )
    }
}

export default ESmmPriceTable;